export default __webpack_public_path__ + "static/media/B3_22.ac51157f.mp3";